import React, { useEffect, useState } from "react";
import { useTable, useSortBy, usePagination } from "react-table";
import { PrevBtn, NextBtn, PaginationWrapper } from "../../Styles/PageStyles";
import Images from "../../../Images";
import tw from "tailwind-styled-components";
import Config, { PaginationLimit } from "../../../Config";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import Tooltip from "../../Tooltip";
import { MdOutlineChevronRight } from "react-icons/md";
import { IoCopySharp } from "react-icons/io5";
import { capitalizeFirstLetter, getAutoPayStatusConfig, handleCopy, truncateText } from "../../../helpers";

const Table = ({
    apiData,
    setSelectedData,
    setViewDetails,
    getTransferListMutate,
    setIsChangeStatus,
}) => {
    const [data, setData] = useState([]);
    const navigate = useNavigate();
    const [selectedRow, setSelectedRow] = useState(null);
    const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);
    const [currentPage, setCurrentPage] = useState(0);

    const toggleRow = (index) => {
        setSelectedRow(selectedRow === index ? null : index);
    };
    const view = (item) => {
        setViewDetails(true);
        setSelectedData(item);
    };
    const changeStatus = (item) => {
        setIsChangeStatus(true);
        setSelectedData(item);
    };
    const viewTransfers = (item) => {
        setSelectedData(item);
        getTransferListMutate(item?.id)
        // setOpenActionMenu(null);
    };
    // Action button with arrow only
    const ActionBtns = (item) => {

        return (
            <div className="flex items-center gap-3">
                <Tooltip label={"Click to view details"}>
                    <button
                        onClick={() => view(item)}
                        className={`px-4 ml-auto transition text-gray-400 hover:text-gray-700 cursor-pointer`}
                    >
                        <MdOutlineChevronRight size={22} />
                    </button>
                </Tooltip>
            </div>
        );
    };

    useEffect(() => {
        if (apiData) {
            const tempData = apiData.map((item) => ({
                beneficiary: getName(item),
                totalAmount: <Amount>₹{Number(item.totalAmount || 0).toLocaleString('en-IN')}</Amount>,
                amountDisplay: getAmountDisplay(item),
                installment: getInstallment(item),
                transactionDisplay: showProgress(item),
                nextDueDate: item.nextDueDate ? moment(item.nextDueDate).format("DD MMM, YYYY") : "--",
                action: ActionBtns(item),
                status: getAutoPayStatus(item),
            }));
            setData(tempData);
        }
    }, [apiData]);

    // const getAutoPayStatus = (item) => {
    //     const { label, color } = getAutoPayStatusConfig(item.status);
    //     return (
    //         <div className="flex items-center gap-2 cursor-pointer"
    //             onClick={() => changeStatus(item)}>

    //             <span className={`text-sm font-semibold ${color}`}>
    //                 {label}
    //             </span>
    //         </div>
    //     );
    // };
    const getAutoPayStatus = (item) => {
        const { label, color } = getAutoPayStatusConfig(item.status);
        const isDisabled = item.status === Config.AUTOPAY_STATUS.COMPLETED || item.status === Config.AUTOPAY_STATUS.CANCELLED;

        return (
            <div
                className={`flex items-center gap-2 ${isDisabled ? 'cursor-not-allowed opacity-75' : 'cursor-pointer'}`}
                onClick={() => !isDisabled && changeStatus(item)}
            >
                <span className={`text-sm font-semibold ${color}`}>
                    {label}
                </span>
            </div>
        );
    };

    const getInstallment = (item) => (
        // <span
        //     className={`text-sm text-gray-600 hover:text-blue-600 cursor-pointer transition`}
        //     onClick={() => viewTransfers(item)}
        // >
        //     {item?.amount || 0}
        // </span>

        <button
            type="button"
            className="group flex flex-col items-start"
            onClick={() => viewTransfers(item)}
        >
            <span className="text-sm font-medium text-gray-700">
                {item?.amount || 0}
            </span>

            <span className="text-xs text-gray-400 group-hover:text-primary-color transition-colors">
                View payout
            </span>
        </button>


    );

    // Amount display: Paid / Outstanding
    const getAmountDisplay = (item) => {
        const paidAmount = Number(item.paidAmount || 0);
        const totalAmount = Number(item.totalAmount || 0);
        const outstandingAmount = totalAmount - paidAmount;

        return (
            <Tooltip
                label={
                    <div className="p-1">
                        <ul className="space-y-1">
                            <li className="text-xs flex items-center gap-1">
                                <span className="font-medium">Paid:</span> ₹{paidAmount.toLocaleString('en-IN')}
                            </li>
                            <li className="text-xs flex items-center gap-1">
                                <span className="font-medium">Outstanding:</span> ₹{outstandingAmount.toLocaleString('en-IN')}
                            </li>
                            <li className="text-xs flex items-center gap-1">
                                <span className="font-medium">Total:</span> ₹{totalAmount.toLocaleString('en-IN')}
                            </li>
                        </ul>
                    </div>
                }
            >
                <div className="flex items-baseline gap-1.5 cursor-help">
                    <span className="text-sm font-medium text-gray-600 tabular-nums">
                        ₹{paidAmount.toLocaleString('en-IN')}
                    </span>
                    <span className="text-xs text-gray-400 font-normal">
                        / ₹{outstandingAmount.toLocaleString('en-IN')}
                    </span>
                </div>
            </Tooltip>
        );
    };

    const showProgress = (item) => {
        const totalTransactions = Number(item.totalTransactions || 0);
        const remainingTransactions = Number(item.transactionsRemaining || 0);

        const completedTransactions = Math.max(
            0,
            totalTransactions - remainingTransactions
        );

        const progress =
            totalTransactions > 0
                ? Math.min(
                    100,
                    Math.round((completedTransactions / totalTransactions) * 100)
                )
                : 0;

        return (
            <div className="w-[110px]">
                <div className="flex items-center justify-between mb-1">
                    <span className="text-sm font-semibold text-gray-700">
                        {completedTransactions}/{totalTransactions}
                    </span>

                    <span className="text-xs text-gray-400">
                        {progress}%
                    </span>
                </div>

                <div className="h-1.5 w-full overflow-hidden rounded-full bg-gray-100">
                    <div
                        className="h-full rounded-full bg-[#0078BD] transition-all duration-300"
                        style={{ width: `${progress}%` }}
                    />
                </div>
            </div>
        );
    };

    const getName = (item) => {
        return (
            <div className="flex flex-col gap-0.5 pl-2 cursor-pointer">
                <Tooltip
                    label={
                        <div className="p-1">
                            <ul className="space-y-1">
                                <li className="text-xs flex items-center gap-1">
                                    <span className="font-medium">Beneficiary ID:</span> #{item.beneficiaryId}
                                </li>
                                <li className="text-xs flex items-center gap-1">
                                    <span className="font-medium">Category:</span> {item.expenseTypeName}
                                </li>
                            </ul>
                        </div>
                    }
                >
                    <div className="flex flex-col min-w-0">
                        <span className="font-medium text-gray-600 truncate">
                            {capitalizeFirstLetter(truncateText(item?.beneficiaryName || "Unknown", 20))}
                        </span>
                        <div className="flex items-center gap-1 text-xs text-gray-400">
                            <span>{'#' + item.beneficiaryMobile}</span>

                            <button
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleCopy(item.beneficiaryMobile);
                                }}
                                className="hover:text-gray-600 transition"
                                title="Copy number"
                            >
                                <IoCopySharp size={12} />
                            </button>

                        </div>

                    </div>
                </Tooltip>
            </div>
        );
    };

    // Get frequency type label
    const getFrequencyLabel = (frequencyType) => {
        const frequencyMap = {
            1: "Daily",
            2: "Weekly",
            3: "Monthly",
            4: "Yearly"
        };
        return frequencyMap[frequencyType] || "--";
    };

    useEffect(() => {
        const handleResize = () => {
            setIsMobileView(window.innerWidth < 768);
        };

        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const columns = React.useMemo(() => {
        if (isMobileView) {
            return [
                {
                    Header: "Beneficiary",
                    accessor: "beneficiary",
                },
                {
                    Header: "Total Amount",
                    accessor: "totalAmount",
                },
                {
                    Header: "",
                    accessor: "action",
                },
            ];
        }
        return [
            {
                Header: "Beneficiary",
                accessor: "beneficiary",
            },
            {
                Header: "Total Amount",
                accessor: "totalAmount",
            },
            {
                Header: "Installment",
                accessor: "installment",
            },
            {
                Header: "Progress",
                accessor: "transactionDisplay",
            },
            {
                Header: "Status",
                accessor: "status",
            },
            {
                Header: "",
                accessor: "action",
            },
        ];
    }, [isMobileView]);

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        prepareRow,
        pageOptions,
        page,
        state: { pageIndex, pageSize },
        previousPage,
        nextPage,
        setPageSize,
        canPreviousPage,
        canNextPage,
    } = useTable(
        {
            data,
            columns,
            initialState: { pageIndex: currentPage, pageSize: PaginationLimit },
        },
        useSortBy,
        usePagination
    );

    useEffect(() => {
        setCurrentPage(pageIndex);
    }, [pageIndex]);

    return (
        <>
            <CustomTable {...getTableProps()}>
                <Thead>
                    {headerGroups.map((headerGroup) => (
                        <Tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column) => (
                                <Th {...column.getHeaderProps(column.getSortByToggleProps())}>
                                    {column.render("Header")}
                                    <span>
                                        {column.isSorted ? (
                                            <img
                                                src={Images.Arrow}
                                                alt="down arrow"
                                                className={`${column.isSortedDesc ? "-rotate-90" : "rotate-90"
                                                    } w-1.5 inline-block ml-1.5`}
                                            />
                                        ) : (
                                            ""
                                        )}
                                    </span>
                                </Th>
                            ))}
                        </Tr>
                    ))}
                </Thead>
                <Tbody {...getTableBodyProps()} hasdata={(apiData?.length > 0).toString()}>
                    {page.map((row, rowIndex) => {
                        prepareRow(row);
                        const rowData = apiData[rowIndex];
                        return (
                            <React.Fragment key={rowIndex}>
                                <Tr
                                    {...row.getRowProps({ style: { height: "80px" } })}
                                    hasdata={(apiData?.length > 0).toString()}
                                >
                                    {row.cells.map((cell, cellIndex) => {
                                        return (
                                            <Td
                                                {...cell.getCellProps()}
                                                onClick={() => {
                                                    if (cellIndex === 0 || cellIndex === 1) {
                                                        toggleRow(rowIndex);
                                                    }
                                                }}
                                            >
                                                {cell.render("Cell")}
                                            </Td>
                                        );
                                    })}
                                </Tr>
                                {selectedRow === rowIndex && window.innerWidth < 768 && (
                                    <Tr>
                                        <Td colSpan={columns.length}>
                                            <ul className="flex flex-col gap-2">
                                                <li>
                                                    <strong>Amount:</strong> {data[rowIndex]?.amountDisplay}
                                                </li>
                                                <li>
                                                    <strong>Transactions:</strong> {data[rowIndex]?.transactionDisplay}
                                                </li>
                                                <li>
                                                    <strong>Due On:</strong> {data[rowIndex]?.nextDueDate}
                                                </li>
                                            </ul>
                                        </Td>
                                    </Tr>
                                )}
                            </React.Fragment>
                        );
                    })}
                </Tbody>
            </CustomTable>
            {apiData?.length > 0 && (
                <PaginationWrapper>
                    <div className="px-2">
                        Page{" "}
                        <em>
                            {pageIndex + 1} of {pageOptions.length}
                        </em>
                    </div>
                    <div className="flex gap-1">
                        <PrevBtn onClick={() => previousPage()} disabled={!canPreviousPage}>
                            <img src={Images.Arrow} alt="arrow" className="w-2 opacity-75" />
                        </PrevBtn>
                        <NextBtn onClick={() => nextPage()} disabled={!canNextPage}>
                            <img
                                src={Images.Arrow}
                                alt="arrow"
                                className="w-2 rotate-180 opacity-75"
                            />
                        </NextBtn>
                    </div>
                </PaginationWrapper>
            )}
        </>
    );
};

const CustomTable = tw.table`w-full text-gray-600`;
const Thead = tw.thead`border-b uppercase text-gray-600 bg-blue-50`;
const Tbody = tw.tbody`${(props) => (props.hasdata === "true" ? "border-b" : "")}`;
const Tr = tw.tr`${(props) =>
    props.hasdata === "true"
        ? "border-b"
        : ""} rounded-md overflow-hidden hover:bg-slate-50`;
const Th = tw.th`text-left text-sm md:p-3 p-0.5 font-normal text-gray-600`;
const Td = tw.td`p-3 text-sm md:p-3 text-left`;
const Amount = tw.p`
  text-gray-800 
  text-sm 
  font-semibold 
  inline-flex 
  min-w-[80px]
  justify-center
`;

export default Table;